import React, {useEffect, useState} from 'react';
import {FormPageRoot, ThemedButton, ThemedDialog, ThemedInput} from "../../../index";
import {useTheme} from "../../../../common/ProjectThemeProvider";
import {checkNullStr, getDefStr, getJsonValue, isBoolTrue, isJsonValueTrue, vhToPx} from "../../../../common/fusion-ui/utils/ReactUtils";
import {focusFormIdElement, getSubdomainSessionData, getUserSessionField, printError, printLog, sendRequest} from "../../../utils/AppUtils";
import {useToast} from "../../../../common/fusion-ui/provider/ToastProvider";
import {EVENT_INPUT_MAX_LEN, INPUT_FILE_MAX_SIZE, ModuleFieldsData, ModuleRouteUrls, Modules, ReqUrls,} from "../../../config/AppConfig";
import {Avatar, Flexbox, GridBox, Image, Label, MsgBox, PdfViewer} from "../../../../common/fusion-ui";
import {Constants, CssVariant, Messages} from "../../../../common/fusion-ui/config/FusionConfig";
import {useInternetStatus} from "../../../../common/fusion-ui/hook";
import {UnderMaintenance, UnderMaintenanceMsg} from "../../../../common/CommonConfig";

const CS_Recom_FormPage = React.memo(({asPanel = false, redirectUrl}) => {
    const TAG = "CS_Recom_FormPage";

    const moduleName = Modules.CaseStudy;
    const FormFields = ModuleFieldsData[moduleName];

    const theme = useTheme();
    const {showToast, changeToastVariant} = useToast();
    const {isOnline, internetCheckingMsg} = useInternetStatus();

    const FOCUS_DELAY = 2000;

    const Fields = {
        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',

        submitBtn_AsLoading: 'submitBtn_AsLoading',
        submitBtn_disabled: 'submitBtn_disabled',

        isPdfFileLoading: 'isPdfFileLoading',

        panelMsg: 'panelMsg',
        panelMsgColor: 'panelMsgColor',

        showSuccessDialog: 'showSuccessDialog',
        successDialogOnHide: 'successDialogOnHide',
    };
    const [fieldsData, setFieldsData] = useState({});
    // const [formData, setFormData] = useState(CS_Recom_FormPage_Data);
    const [formData, setFormData] = useState({});
    const [formFieldsMsgs, setFormFieldsMsgs] = useState({});

    useEffect(() => {
        // setFormData({});
        if (!checkNullStr(getField(Fields.isDataFound))) {
            updateField(Fields.isDataFound, true);
            updateField(Fields.isDataLoading, false);
        }
    }, []);

    return (<>
        {isBoolTrue(asPanel) ? createForm() : createFormPage()}
        {createSuccessDialog()}
    </>)

    function createFormPage() {
        return <FormPageRoot
            tag={TAG}
            moduleName={moduleName}
            addPageTitle={getTabTitle()}
            isDataLoading={getField(Fields.isDataLoading)}
            isDataFound={getField(Fields.isDataFound)}
            dataLoadingMsg={getField(Fields.dataLoadingMsg)}
            md={6}>
            {createForm()}
        </FormPageRoot>
    }

    function createForm() {
        return <div>
            {/*title, author, date, link*/}
            <div>
                {/*title*/}
                <ThemedInput
                    wrapperClassName={''}
                    className={''}
                    label={FormFields.title.title}
                    placeholder={FormFields.title.title}
                    id={FormFields.title.column}
                    type={'text'}
                    value={getFormField(FormFields.title)}
                    msg={getFormFieldMsg(FormFields.title)}
                    showLimitLabel={true}
                    maxLength={EVENT_INPUT_MAX_LEN}
                    required={true}
                    onChange={(e) => {
                        const value = e.target.value;
                        updateFormField(FormFields.title, value);
                        if (checkNullStr(value)) updateFormFieldMsg(FormFields.title, '');
                    }}
                />

                {/*date*/}
                <ThemedInput
                    wrapperClassName={''}
                    className={''}
                    label={FormFields.date.title}
                    placeholder={FormFields.date.title}
                    id={FormFields.date.column}
                    type={'date'}
                    value={getFormField(FormFields.date)}
                    msg={getFormFieldMsg(FormFields.date)}
                    required={true}
                    onChange={(e) => {
                        const value = e.target.value;
                        updateFormField(FormFields.date, value);
                        if (checkNullStr(value)) updateFormFieldMsg(FormFields.date, '');
                    }}
                />

                {/*author*/}
                <ThemedInput
                    wrapperClassName={''}
                    className={''}
                    label={FormFields.author.title}
                    placeholder={FormFields.author.title}
                    id={FormFields.author.column}
                    type={'text'}
                    value={getFormField(FormFields.author)}
                    msg={getFormFieldMsg(FormFields.author)}
                    showLimitLabel={true}
                    maxLength={EVENT_INPUT_MAX_LEN}
                    required={true}
                    onChange={(e) => {
                        const value = e.target.value;
                        updateFormField(FormFields.author, value);
                        if (checkNullStr(value)) updateFormFieldMsg(FormFields.author, '');
                    }}
                />

                {/*desc*/}
                <ThemedInput
                    wrapperClassName={''}
                    className={''}
                    label={FormFields.desc.title}
                    placeholder={FormFields.desc.title}
                    id={FormFields.desc.column}
                    type={'text'}
                    value={getFormField(FormFields.desc)}
                    msg={getFormFieldMsg(FormFields.desc)}
                    showLimitLabel={true}
                    maxLength={EVENT_INPUT_MAX_LEN}
                    asTextArea={true}
                    style={{
                        minHeight: '50px',
                        height: '80px',
                        maxHeight: '200px'
                    }}
                    required={true}
                    onChange={(e) => {
                        const value = e.target.value;
                        updateFormField(FormFields.desc, value);
                        if (checkNullStr(value)) updateFormFieldMsg(FormFields.desc, '');
                    }}
                />


            </div>

            {/*file, desc*/}
            <div className={'mt-3x'}>
                <GridBox className={'px-2'} md={[4, 8]} sm={[12, 12]}>
                    {/*file*/}
                    <div className={''}>
                        <Avatar
                            wrapperClassName={'w-100'}
                            className={''}
                            labelClassName={'w-100x pb-2 text-startxx'}
                            justifyAt={'center'}
                            alignAt={'start'}
                            wrap={'wrap'}
                            direction={'column'}
                            label={FormFields.file.title}
                            labelColor={theme.text40}
                            accept={'.pdf, .jpg, .jpeg, .png'}
                            editTooltip={`Edit (.pdf, .jpg, .jpeg, .png)`}
                            showEdit={true}
                            showDelete={true}
                            circular={false}
                            showFullPreviewDialog={true}
                            defAvatarImg={Constants.docVector}
                            editSize={'21px'}
                            width={'100px'}
                            height={'140px'}
                            maxSize={INPUT_FILE_MAX_SIZE}
                            onChange={(e, file, path, name, ext) => {
                                log('Avatar.file.onChange.name:', name, 'ext:', ext);
                                updateFormField(FormFields.file, file);
                                updateFormField(FormFields.docFileExt, ext);
                            }}
                            onInvalidFormat={(e, name) => {
                                toast(`Invalid file format. File must be pdf, jpg, jpeg or png`, CssVariant.danger);
                            }}
                            onSizeExceeded={() => {
                                toast(`Max size exceeded: ${INPUT_FILE_MAX_SIZE}`, CssVariant.danger);
                            }}
                            onFileLoading={(loading) => {
                                updateField(Fields.isPdfFileLoading, isBoolTrue(loading));
                            }}>{getFormField(FormFields.file)}</Avatar>
                    </div>

                    {/*pdf-viewer*/}
                    {(checkNullStr(getFormField(FormFields.file)) &&
                            (getFormField(FormFields.docFileExt) + '').toLowerCase().trim().endsWith('.pdf')
                            && !isFieldTrue(Fields.isPdfFileLoading)) &&
                        <div className={'ps-3x pb-4'}>
                            <PdfViewer
                                label={`${FormFields.file.title} Preview`}
                                pdfTitle={FormFields.file.title}
                                src={getFormField(FormFields.file)}
                                labelColor={theme.text}
                                height={'240px'}
                            />
                        </div>}
                </GridBox>
            </div>

            {/*url*/}
            <ThemedInput
                wrapperClassName={'mt-3'}
                className={''}
                label={FormFields.url.titleAlt3}
                placeholder={FormFields.url.titleAlt3}
                id={FormFields.url.column}
                type={'text'}
                value={getFormField(FormFields.url)}
                msg={getFormFieldMsg(FormFields.url)}
                showLimitLabel={true}
                maxLength={EVENT_INPUT_MAX_LEN}
                required={true}
                onChange={(e) => {
                    const value = e.target.value;
                    updateFormField(FormFields.url, value);
                    if (checkNullStr(value)) updateFormFieldMsg(FormFields.url, '');
                }}
            />

            {/*by*/}
            <ThemedInput
                label={"Recommended by"}
                placeholder={"Recommended by"}
                value={getUserSessionField('fullName')}
                readOnly={true}
            />

            {/*footer*/}
            <div className={'mt-3'}>
                {/*msg-box*/}
                {checkNullStr(getField(Fields.panelMsg)) && <MsgBox color={getField(Fields.panelMsgColor, theme.text)}>
                    {getField(Fields.panelMsg)}
                </MsgBox>}

                {/*controls*/}
                <Flexbox className={'mt-2'} justifyAt={'center'} alignAt={'center'}>
                    <ThemedButton
                        className={'rounded-2 w-auto px-4 py-1'}
                        text={isFieldTrue(Fields.submitBtn_AsLoading) ? 'Uploading...' : 'Upload'}
                        variant={theme.primaryBlue}
                        hoverBgColor={theme.primaryBlueDark}
                        loadingWidth={'auto'}
                        asLoading={isFieldTrue(Fields.submitBtn_AsLoading)}
                        disabled={isFieldTrue(Fields.submitBtn_disabled)}
                        onClick={handleSubmit}
                    />
                </Flexbox>
            </div>
        </div>
    }

    function createSuccessDialog() {
        return <ThemedDialog
            className={"rounded-6 p-0 m-0"}
            titleClassName={'fs-lg mb-2'}
            open={isFieldTrue(Fields.showSuccessDialog)}
            title={"Thanks"}
            showClose={true}
            showFooter={false}
            closeOnEscape={true}
            closeOnOutsideClick={true}
            onHide={() => {
                const onHide = getField(Fields.successDialogOnHide);
                if (onHide) onHide();
                // updateField(Fields.showSuccessDialog, false);
            }}
        >
            <div className={'px-3'}>
                <div className={'m-0 p-0 pt-1 px-2 d-none-smx h-100 auth-img-wrapper w-100'}>
                    <Image
                        wrapperClassName={`w-100 rounded-6 overflow-hidden select-none`}
                        className={`auth-ra-img transition-sm`}
                        src={"https://cdn.pixabay.com/photo/2016/11/07/00/49/thanks-1804597_1280.jpg"}
                        // src={"https://cdn.pixabay.com/photo/2020/04/22/11/59/thank-you-5077738_1280.jpg"}
                        width={'100%'}
                        height={vhToPx('60vh') + 'px'}
                        objectFit={'cover'}
                        disableDrag={true}
                    />
                </div>

                <div>
                    <div className={'w-100 d-flex jc-center'}>
                        <Label className={'text-wrap fw-semi-bold mt-3 fs-normal'} color={theme.text80} textAt={'center'}>
                            {getDefStr(getField(Fields.panelMsg), Messages.formDataSaveSuccess)}
                        </Label>
                    </div>
                    <div className={'w-100 d-flex jc-center'}>
                        <Label className={'text-wrap fw-bold fs-xl'} color={theme.primaryBlue} textAt={'center'}>
                            {"Many thanks for your kind recommendation."}
                        </Label>
                    </div>
                </div>
            </div>
        </ThemedDialog>
    }

    //======================Request Functions start=====================
    function handleSubmit() {
        const fun = 'handleSubmit:';
        log(fun, 'formData:', formData);
        if (UnderMaintenance) {
            toast(UnderMaintenanceMsg, CssVariant.warning);
            return false;
        }
        if (!isOnline) {
            toast(internetCheckingMsg, CssVariant.warning);
            return false;
        }

        try {
            let allFieldsChecked = checkRequiredFields();
            // allFieldsChecked = false;//for checking
            if (allFieldsChecked) {
                updateField(Fields.submitBtn_AsLoading, true);
                updateField(Fields.submitBtn_disabled, true);

                const REQUEST_OPTIONS = {
                    fromRecommendPage: true,
                    browserUrl: window.location.href,
                    formData: formData,
                    subdomainData: getSubdomainSessionData(),
                };
                sendRequest({
                    reqUrl: ReqUrls.cs__addEditPage_submit_formData,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        const message = getJsonValue(fetchedData, 'message');
                        const success = isJsonValueTrue(fetchedData, 'success');

                        // updateField(Fields.submitBtn_disabled, false);//for testing only
                        if (success) {
                            toast(message, CssVariant.success);

                            updateField(Fields.successDialogOnHide, (() => {
                                updateField(Fields.showSuccessDialog, false);
                                if (redirectUrl != -1) window.location.href = getDefStr(redirectUrl, ModuleRouteUrls[moduleName]);
                            }));
                            updateField(Fields.showSuccessDialog, true);
                        } else {
                            toast(message, CssVariant.danger);
                            updateField(Fields.submitBtn_disabled, false);
                        }
                        updateField(Fields.submitBtn_AsLoading, false);
                    }),
                    onError: ((error) => {
                        toast(Messages.saveError, CssVariant.danger);
                        updateField(Fields.submitBtn_AsLoading, false);
                        updateField(Fields.submitBtn_disabled, false);
                        logErr(fun, error);
                    }),
                });
            }
        } catch (error) {
            toast(Messages.saveError, CssVariant.danger);
            updateField(Fields.submitBtn_AsLoading, false);
            updateField(Fields.submitBtn_disabled, false);
            logErr(fun, error);
        }
    }

    //======================Request Functions end=====================

    //======================Util Functions start=====================
    function checkRequiredFields() {
        const fun = 'checkRequiredFields:';
        const requiredFields = [
            FormFields.title,
            FormFields.author,
            FormFields.date,
            FormFields.url,
            FormFields.desc,
        ];

        let verified = false;
        let colField = {};
        for (const field of requiredFields) {
            if (!checkNullStr(formData[field.column])) {
                colField = field;
                verified = false;
                break;
            } else {
                verified = true;
            }
        }
        if (!verified) {
            // log(fun, "!verified.colField:", colField, 'idToFocus:', colField.column);
            updateFormFieldMsg(colField, 'Required field');
            toast(`'${colField.title}' cannot be empty!`, CssVariant.danger);
            focusIdField(colField.column);
        }
        return verified;
    }

    function focusIdField(id, onlyFocus = false) {
        focusFormIdElement(id, onlyFocus, FOCUS_DELAY);
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function updateFormField(clmField, value, direct = false) {
        setFormData(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormField(clmField, defValue, direct = false) {
        return getJsonValue(formData, direct ? clmField : clmField.column, defValue);
    }

    function isFormFieldTrue(clmField, direct = false) {
        return isBoolTrue(getFormField(clmField, null, direct), true, true);
    }

    function updateFormFieldMsg(clmField, value, direct = false) {
        setFormFieldsMsgs(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormFieldMsg(clmField, defValue, direct = false) {
        return getJsonValue(formFieldsMsgs, direct ? clmField : clmField.column, defValue);
    }

    function getTabTitle() {
        return `Recommend ${moduleName}`;
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function panelLog(text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, theme.text90);
        log(...[text]);
    }

    function panelLogErr(...text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, 'red');
        log(...[text]);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

    //======================Util Functions end=====================
});
export default CS_Recom_FormPage;
